<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
    [style.height]="'100%'"
    [text]="' '"
    [blockUI]="true"
    [displayDelay]="20"
    [timeToComplete]="this.uiLoadingIndicatorTimeout"
    (complete)="onBusyIndicatorComplete($event)"
    [transparentOverlay]="true"
>
  <!-- USE FLEX LAYOUT -->
  <div class="scrollable-flex" [style.height]="'100%'">
    <div class="scrollable-flex-content" [ngClass]="listGridScrollableContentClasses">
      <div soho-datagrid #SohoDataGrid
          *ngIf="gridOptions"

          [attr.id]="dataGridId"
          [attr.data-automation-id]="dataGridAutomationId"
          [gridOptions]="this.gridOptions"
          [emptyMessage]="this.emptyMessage"
          [ngClass]="showEmptyMessageOnList"

          (cellchange)="onCellChange($event)"
          (rowAdd)="onRowAdd($event)"
          (closeFilterRow)="onCloseFilterRow($event)"
          (openFilterRow)="onOpenFilterRow($event)"
          (contextMenu)="onContextMenu($event)"
          (entereditmode)="onEnterEditMode($event)"
          (filtered)="onFilterPage($event)"
          (keydown)="onKeyDown($event)"
          (rendered)="onRendered($event)"
          (rowActivated)="onRowActivated($event)"
          (rowDeactivated)="onRowDeactivated($event)"
          (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)"
          (selected)="onRowSelected($event)"
          (settingsChanged)="onSettingsChanged($event)"
          (sorted)="onSortPage($event)"
          (filteroperatorchanged)="onFilterOperatorChanged($event)"
      ></div>
    </div>

    <!-- FLEX FOOTER -->
    <div soho-standalone-pager *ngIf="!hidePagerBar"
        class="scrollable-flex-footer"
        id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
        [attr.data-automation-id]="pagerAutomationId"
        [attributes]="pagerIdAttributes"
        [smallPageSizeSelector]="true"
        [pageSizeMenuSettings]="{ attachToBody: true }"
        [showPageSizeSelector]="showPageSizeChooser"

        [enableFirstButton]="enableFirstPage"
        [enablePreviousButton]="enablePreviousPage"
        [enableNextButton]="enableNextPage"
        [enableLastButton]="enableLastPage"

        [firstPageTooltip]="firstPageButtonTooltip"
        [previousPageTooltip]="previousPageButtonTooltip"
        [nextPageTooltip]="nextPageButtonTooltip"
        [lastPageTooltip]="lastPageButtonTooltip"

        [pageSize]="pageSize"
        [pageSizes]="pageSizes"

        (firstPage)="onFirstPage($event)"
        (previousPage)="onPreviousPage($event)"
        (nextPage)="onNextPage($event)"
        (lastPage)="onLastPage($event)"
        (pageSizeChange)="onPageSizeChange($event)"
    ></div>
  </div>
  <div class="audible"> 
   <p aria-hidden="true" aria-live="polite">{{searchResultText}}</p>
  </div>
</div>
